// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"7993b7ff","320":"48d11057","388":"626c7bcf","405":"3d978be1","453":"aacd9a41","553":"2d172dd5","744":"94781e0c"}[chunkId] + ".css";
};